"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var BLE_CONTROL = {

  readingStorageName: "mymobile_collections_duplicate_readings",

  enabled: false,
  has_ble: false,
  supported_devices: [],
  activeReader: null,

  _success: function _success(result) {
    console.log(result);
  },

  _failure: function _failure(error) {
    console.error(error);
  },

  identifyDevicesBySerialNumber: function identifyDevicesBySerialNumber() {
    return deviceOS == 'iOS';
  },

  initializeSupportedDeviceMap: function initializeSupportedDeviceMap() {
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "TunstallBPU329BTBPType", class_name: "Tunstall_BPU329" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "TunstallBW129BTWSType", class_name: "Tunstall_BW129" });

    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android", "iOS"], model_identifier: "Nonin3230BTType", class_name: "Nonin_3230" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android", "iOS"], model_identifier: "TaiDocTD1261BLEType", class_name: "Taidoc_1261_BLE" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android", "iOS"], model_identifier: "TaiDocTD1261BLE_F_Type", class_name: "Taidoc_1261_BLE_F" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android", "iOS"], model_identifier: "TaiDocBPUTD3128Type", class_name: "Taidoc_3128" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android", "iOS"], model_identifier: "TaiDocGCTD4286ABLEType", class_name: "Taidoc_4286A" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android", "iOS"], model_identifier: "TaiDocWSTD2555Type", class_name: "Taidoc_2555" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android", "iOS"], model_identifier: "RevlisCmateECGType", class_name: "Revlis_CMATE" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android", "iOS"], model_identifier: "ADUA651BLEBPUType", class_name: "AnD_651" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android", "iOS"], model_identifier: "ADUC352BLEWSType", class_name: "AnD_352" });

    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "ADBTBP767CIType", class_name: "AND_UA_767BT_Ci" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "ADBTWS351CIType", class_name: "AND_UC_351PBT_Ci" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "ADBTWS355CIType", class_name: "AND_UC_355PBT_Ci" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "MyGlucoHealthBTType", class_name: "Myglucohealth" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "HdpOmronBPBTType", class_name: "Omron708BT" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "OmronBPBTType", class_name: "Omron708BT" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "TaiDocTD1261BTType", class_name: "TaidocTD1261" });
    BLE_CONTROL.supported_devices.push({ supported_platforms: ["Android"], model_identifier: "NoninOnyx2BTType", class_name: "Nonin_9560BT" });
  },

  getNewDeviceByModelIdentifier: function getNewDeviceByModelIdentifier(id) {
    var found_device, device_listing;

    for (var i = 0; i < BLE_CONTROL.supported_devices.length; i++) {
      device_listing = BLE_CONTROL.supported_devices[i];
      if (device_listing.model_identifier == id && $.inArray(deviceOS, device_listing.supported_platforms) != -1) {
        found_device = eval("new " + device_listing.class_name + "('00:00:00:00:00:00')");
      }
    }
    return found_device;
  },

  checkBLE: function checkBLE() {
    var deferred = $.Deferred();

    var has_ble = function has_ble() {
      console.log("BLE is present");
      BLE_CONTROL.has_ble = true;
      deferred.resolve();
    };
    var no_ble = function no_ble() {
      console.log("BLE is NOT present");
      BLE_CONTROL.has_ble = false;
      deferred.reject();
    };

    if (inBrowser) {
      deferred.reject();
    } else if (deviceOS == 'iOS') {
      ble.isEnabled(has_ble, no_ble);
    } else {
      medicalSensors.hasBLE(has_ble, no_ble);
    }
    return deferred.promise();
  },

  checkIfEnabled: function checkIfEnabled() {
    var isEnabled = function isEnabled() {
      console.log("Bluetooth is enabled");
      BLE_CONTROL.enabled = true;
    };

    var isNotEnabled = function isNotEnabled() {
      console.log("Bluetooth is *not* enabled");
      BLE_CONTROL.enabled = false;
    };

    // https://github.com/don/cordova-plugin-ble-central#isenabled
    if (inBrowser) {
      isNotEnabled();
    } else if (deviceOS == 'iOS') {
      ble.isEnabled(isEnabled, isNotEnabled);
    } else if (deviceOS == 'Android') {
      medicalSensors.isEnabled(isEnabled, isNotEnabled);
    } else {
      isNotEnabled();
    }
  },

  enable: function enable() {
    // https://github.com/don/cordova-plugin-ble-central#enable
    // only supported on Android and does not work on iOS.
    medicalSensors.enable(function () {
      BLE_CONTROL.checkIfEnabled();BLE_CONTROL._success;
    }, function () {
      BLE_CONTROL.checkIfEnabled();BLE_CONTROL._success;
    });
  },

  enableDeferred: function enableDeferred() {
    // https://github.com/don/cordova-plugin-ble-central#enable
    // only supported on Android and does not work on iOS.
    var deferred = $.Deferred();
    if (inBrowser) {
      deferred.reject();
    } else if (deviceOS == "iOS") {
      ble.isEnabled(function () {
        deferred.resolve();
      }, function () {
        deferred.reject();
      });
    } else {
      medicalSensors.enable(function () {
        BLE_CONTROL.checkIfEnabled();deferred.resolve();
      }, function () {
        BLE_CONTROL.checkIfEnabled();deferred.reject();
      });
    }
    return deferred.promise();
  },

  enablePromise: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var finishEnabled = function finishEnabled() {
                  BLE_CONTROL.enabled = true;
                  resolve(true);
                };

                var finishDisabled = function finishDisabled() {
                  BLE_CONTROL.enabled = false;
                  resolve(false);
                };

                var check = function check() {
                  medicalSensors.isEnabled(finishEnabled, finishDisabled);
                };

                var turnOn = function turnOn() {
                  medicalSensors.enable(check, check);
                };

                if (inBrowser) {
                  finishDisabled();
                } else if (deviceOS == "iOS") {
                  ble.isEnabled(finishEnabled, finishDisabled);
                } else {
                  medicalSensors.isEnabled(finishEnabled, turnOn);
                }
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function enablePromise() {
      return _ref.apply(this, arguments);
    }

    return enablePromise;
  }(),

  checkIfEnabledPromise: function checkIfEnabledPromise() {
    return new Promise(function (resolve, reject) {
      var finish = function finish(enabled) {
        BLE_CONTROL.enabled = enabled;
        resolve(enabled);
      };
      if (inBrowser) {
        finish(false);
      } else if (deviceOS == 'iOS') {
        ble.isEnabled(function () {
          finish(true);
        }, function () {
          finish(false);
        });
      } else {
        medicalSensors.isEnabled(function () {
          finish(true);
        }, function () {
          finish(false);
        });
      }
    });
  },

  showSettings: function showSettings() {
    // https://github.com/don/cordova-plugin-ble-central#showbluetoothsettings
    // not supported on iOS
    medicalSensors.showBluetoothSettings(BLE_CONTROL._success, BLE_CONTROL._failure);
  },

  getActiveReader: function getActiveReader() {
    return this.activeReader;
  },

  saveTempReading: function saveTempReading(id, hash, date, success, failure) {
    console.log("BLE Control: Saving temp reading.");
    if (deviceOS == 'Android') {
      medicalSensors.saveTempReading(id, hash, success, failure);
    } else {

      var currentDuplicates = JSON.parse(localStorage.getItem(BLE_CONTROL.readingStorageName));

      if (!currentDuplicates) {
        currentDuplicates = {};
      }

      if (!currentDuplicates[id]) {
        currentDuplicates[id] = {};
      }
      currentDuplicates[id][hash] = { date: date, confirmed: false };

      if (BLE_CONTROL.saveReadingsLocal(currentDuplicates)) {
        success("Saved temporary readings.");
      } else {
        failure("Could not save temp readings.");
      }
    }
  },

  saveReadingsLocal: function saveReadingsLocal(duplicates) {
    try {
      localStorage.setItem(BLE_CONTROL.readingStorageName, JSON.stringify(duplicates));
    } catch (e) {
      console.error("Cannot save readings. Most likely out of local storage memory.");
      console.error(e);
      return false;
    }
    return true;
  },

  confirmTempReadings: function confirmTempReadings(success, failure) {
    console.log("Confirming temporary readings.");
    if (deviceOS == 'Android') {
      medicalSensors.confirmTempReadings(success, failure);
    } else {
      //Use localstorage
      var duplicates = JSON.parse(localStorage.getItem(BLE_CONTROL.readingStorageName));

      if (!duplicates) {
        failure("Could not confirm temporary readings.");
        return;
      }

      for (var id in duplicates) {
        for (var checksum in duplicates[id]) {
          duplicates[id][checksum].confirmed = true;
        }
      }

      if (BLE_CONTROL.saveReadingsLocal(duplicates)) {
        success();
      } else {
        failure("Could not confirm temporary readings.");
      }
    }
  },

  clearTempReadings: function clearTempReadings(success, failure) {
    if (deviceOS == 'Android') {
      medicalSensors.clearTempReadings(success, failure);
    } else {
      var duplicates = JSON.parse(localStorage.getItem(BLE_CONTROL.readingStorageName));

      if (!duplicates) {
        return;
      }

      for (var uuid in duplicates) {
        var checksumsToDelete = [];
        for (var checksum in duplicates[uuid]) {
          if (!duplicates[uuid][checksum].confirmed) {
            checksumsToDelete.push(checksum);
          }
        }

        for (var index in checksumsToDelete) {
          delete duplicates[uuid][checksumsToDelete[index]];
        }
      }

      BLE_CONTROL.saveReadingsLocal(duplicates);
    }
  },

  clearOlderTempReadings: function clearOlderTempReadings(uuid, date) {
    var duplicates = JSON.parse(localStorage.getItem(BLE_CONTROL.readingStorageName));

    if (!date || !duplicates || !duplicates[uuid]) {
      return;
    }

    var checksumsToDelete = [];
    for (var checksum in duplicates[uuid]) {
      if (new Date(duplicates[uuid][checksum].date).getTime() < date.getTime()) {
        checksumsToDelete.push(checksum);
      }
    }

    for (var index in checksumsToDelete) {
      delete duplicates[uuid][checksumsToDelete[index]];
    }

    BLE_CONTROL.saveReadingsLocal(duplicates);
  },

  setActiveReader: function setActiveReader(reader) {
    this.stopActiveReader();
    this.activeReader = reader;
    return this.activeReader;
  },

  stopActiveReader: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(device) {
      var ar;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.activeReader) {
                _context2.next = 5;
                break;
              }

              ar = this.activeReader;

              this.activeReader = null;
              _context2.next = 5;
              return ar.stop();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function stopActiveReader(_x) {
      return _ref2.apply(this, arguments);
    }

    return stopActiveReader;
  }(),

  stopAllReadings: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (inBrowser) {
                _context3.next = 5;
                break;
              }

              console.log("Stopping Bluetooth.");

              if (deviceOS == 'Android') {
                medicalSensors.stopReading(BLE_CONTROL._success, BLE_CONTROL._failure);
              }
              _context3.next = 5;
              return this.stopActiveReader();

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function stopAllReadings() {
      return _ref3.apply(this, arguments);
    }

    return stopAllReadings;
  }(),

  lookupReading: function lookupReading(device_uuid, checksum, success, failure) {
    if (deviceOS == "Android") {
      medicalSensors.lookupReading(device_uuid, checksum, success, failure);
    } else {
      var duplicates = JSON.parse(localStorage.getItem(BLE_CONTROL.readingStorageName));

      if (duplicates && duplicates[device_uuid] && duplicates[device_uuid][checksum] && duplicates[device_uuid][checksum].confirmed) {
        success("FOUND");
      } else {
        failure("Record not found.");
      }
    }
  }

};